import { IconStatusNew, Text } from '@genial/components';

export interface ContractDateProps {
  waitingResponse: boolean;
  contractDate?: string;
}

export const ContractDate = ({ waitingResponse, contractDate }: ContractDateProps) => {
  if (waitingResponse) {
    return <IconStatusNew color="scale.base.400" icon="BackInTime" status="Aguardando..." />;
  }

  if (!contractDate) {
    return <Text>N/A</Text>;
  }

  return <Text>{contractDate}</Text>;
};
